(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-editorial"]) return;
  try {
    
  function setupEditorialFooter(root) {
    root.querySelectorAll('.if-footer').forEach((footer) => {
      if (footer.dataset.initialized) return;
      footer.dataset.initialized = 'true';
      const controller = new AbortController();
      footer.footerCleanup = () => controller.abort();
      const desktop = window.matchMedia('(min-width: 1000px)');
      const grid = footer.querySelector('.if-grid');
      const contact = grid.querySelector('.if-contact');
      const menus = grid.querySelectorAll('.if-nav__details');
      const sync = () => {
        if (desktop.matches) grid.appendChild(contact);
        else grid.insertBefore(contact, grid.querySelector('.if-nav'));
        menus.forEach((details) => {
          details.open = desktop.matches;
          const summary = details.querySelector('summary');
          if (desktop.matches) summary.setAttribute('tabindex', '-1');
          else summary.removeAttribute('tabindex');
        });
      };
      menus.forEach((details) => details.querySelector('summary').addEventListener('click', (event) => {
        if (desktop.matches) event.preventDefault();
      }, { signal: controller.signal }));
      desktop.addEventListener('change', sync, { signal: controller.signal });
      sync();
    });
  }
  setupEditorialFooter(document);
  document.addEventListener('shopify:section:load', (event) => setupEditorialFooter(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.if-footer').forEach((footer) => footer.footerCleanup?.());
  });

  } catch(e) { console.error(e); }
})();
})();
